import classes from "./DescPix.module.scss";
import { useState, useEffect, useContext } from "react";
import InputCheckbox from "../../../../../UI/Inputs/InputCheckbox/InputCheckbox";
import SystemContext from "../../../../../../context/SystemContext";
import { useTranslation } from "react-i18next";

// Material UI imports
import {
  Alert
} from "@mui/material";

const DescPix = () => {
  const { t } = useTranslation();
  const { CheckError, setCheckError } = useContext(SystemContext);
  const [checked, setChecked] = useState(false);
  const [NotExistError, setNotExistError] = useState();
  const [errorRule, setErrorRule] = useState({
    checkbox: null,
  });

  const handleChange = (event) => {
    setChecked(event.target.checked);
    setErrorRule((prevState) => ({
      ...prevState,
      checkbox: !event.target.checked,
    }));
  };

  useEffect(() => {
    setNotExistError(
      Object.values(errorRule).every((value) => value === false)
    );
  }, [errorRule]);

  useEffect(() => {
    if (NotExistError) {
      setCheckError((prevState) => ({
        ...prevState,
        pix: true,
      }));
    } else {
      setCheckError((prevState) => ({
        ...prevState,
        pix: false,
      }));
    }
  }, [NotExistError, checked]);
  useEffect(() => {
    if (CheckError.creditCardShowError) {
      const element = document.getElementById("errorCheckbox");
      const yOffset = window.innerHeight * 0.2;
      const y = element.getBoundingClientRect().top + window.pageYOffset - yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [CheckError]);

  return (
    <div className={classes.DescPix}>
      <div className={classes.Title}>{t("purchase.pix")}</div>
      <li className={classes.TextOne}>
        {t("purchase.pix_message_one")}
      </li>
      <li className={classes.TextTwo}>
        {t("purchase.pix_message_two")}
      </li>
      <li className={classes.TextThree}>
        {t("purchase.pix_message_three")}
      </li>
      <div className={classes.UseTerms}>
        <InputCheckbox
          data-testid="payment_termsCheckbox_span"
          checked={checked}
          label={
            <div>
              {t("purchase.i_declare_that_i_have_read_and_accept_the")}{" "}
              <a
                href="https://termos.probrain.com.br/pub/terms/terms_2022.pdf"
                target="_blank"
                rel="noreferrer"
              >
                {t("purchase.terms_of_use")}
              </a>{" "}
              {t("purchase.and_the")}{" "}
              <a
                href="https://termos.probrain.com.br/pub/policies/policies_2022.pdf"
                target="_blank"
                rel="noreferrer"
              >
                {t("purchase.privacy_policy")}
              </a>
              .
            </div>
          }
          onChange={handleChange}
        />
        <div className={classes.UseTermsError} id="errorCheckbox">
          {CheckError.creditCardShowError && <Alert severity="error" sx={{ mb: 1 }}>
            {t("purchase.mark_the_acceptance_form")}
          </Alert>}
        </div>
      </div>
    </div>
  );
};
export default DescPix;
